import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Snackbar, Alert } from "@mui/material";

import { Header, MainColorButton, Loading } from "../../../components";
import { bottomButton } from "../../../common/styles";
import { saveCustomerInfo } from "../../../server/axios";
import { CUSTOMER_INFO_INDEX_AND_NAME } from "../../../common/constants";
import { CUSTOMER_RESULT } from "../../../routes/path";
import BaseInfoArea from "../baseInfoArea";
import store from "../../../store";

/**
 * 利用者情報登録画面
 * @returns
 */
const CustomerCreator = () => {
  const navigate = useNavigate();

  //初期データ
  const [data, setData] = useState({
    //姓
    lastName: "",
    //名
    firstName: "",
    //姓かな
    lastNameKana: "",
    //名かな
    firstNameKana: "",
    //性別
    gender: "",
    //生年月日
    birthday: null,
    //減免フラグ
    exemptionFlg: null,
    //郵便番号
    postalCode: "",
    //都道府県
    prefecture: "",
    //市区町村
    municipalities: "",
    //町名番地
    townNameAddress: "",
    //建物名等
    buildingNameEtc: "",
    //電話番号
    phoneNumber: "",
  });

  const [endY, setEndY] = useState(0);
  //Loadingコンポネント表示非表示state
  const [loadingOpen, setLoadingOpen] = useState(false);
  //エラーメッセージ表示
  const [openSnackbar, setOpenSnackbar] = useState({
    status: false,
    message: "",
  });
  const handleSnackbarClose = () => {
    setOpenSnackbar({
      status: false,
      message: "",
    });
  };

  const signUp = () => {
    // 必須入力チェック
    const emptyCustomerInfo = [
      data.lastName,
      data.firstName,
      data.lastNameKana,
      data.firstNameKana,
      data.gender,
      data.birthday,
      data.postalCode,
      data.prefecture,
      data.municipalities,
      data.townNameAddress,
      data.phoneNumber,
      data.exemptionFlg,
    ]
      .map((info, index) => {
        if (typeof info === "boolean") {
          return info === null
            ? CUSTOMER_INFO_INDEX_AND_NAME[index]
            : undefined;
        } else {
          return !info ? CUSTOMER_INFO_INDEX_AND_NAME[index] : undefined;
        }
      })
      .filter((index) => index !== undefined);
    if (emptyCustomerInfo.length > 0) {
      setOpenSnackbar({
        status: true,
        message: (
          <>
            以下の必須項目を入力してください。
            {emptyCustomerInfo.map((info, index) => (
              <div key={index} style={{ display: "inline" }}>
                <br />
                <strong>{info}</strong>
              </div>
            ))}
          </>
        ),
      });
      return;
    }

    //電話番号桁数チェック
    if (data.phoneNumber.split("").length !== 11) {
      setOpenSnackbar({
        status: true,
        message: "11桁の電話番号を入力してください。",
      });
      return;
    }

    const selectLineInfo = (state) => state.prescription.lineInfo;
    const lineInfo = selectLineInfo(store.getState());
    setLoadingOpen(true);
    saveCustomerInfo({
      ...data,
      lineId: lineInfo.lineId,
      liffId: lineInfo.liffId,
    }).then((res) => {
      if (res.data.result === -1) {
        //排他エラー処理
        setOpenSnackbar({
          status: true,
          message: `利用者登録に失敗しました。再度ご登録をお願いします。`,
        });
        setLoadingOpen(false);
        return;
      }

      setLoadingOpen(false);
      navigate(CUSTOMER_RESULT, {
        state: {
          header: "利用者登録",
          message: "利用者情報が登録されました。",
        },
      });
    });
  };

  return (
    <>
      <Loading open={loadingOpen} />
      <Header title="利用者登録[本人]" />
      <Snackbar
        open={openSnackbar.status}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleSnackbarClose}
        sx={{ mt: "8vh" }}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          onClose={handleSnackbarClose}
        >
          {openSnackbar.message}
        </Alert>
      </Snackbar>
      <Box
        marginTop="9vh"
        width="95%"
        marginLeft="auto"
        marginRight="auto"
        sx={{ height: "76vh", overflowY: "scroll" }}
        onTouchStartCapture={(e) => {
          setEndY(0);
        }}
        onTouchMoveCapture={(e) => {
          setEndY(e.touches[0].clientY);
        }}
        onTouchEndCapture={(e) => {
          if (endY !== 0) {
            e.stopPropagation();
          }
        }}
      >
        <BaseInfoArea
          setLoadingOpen={setLoadingOpen}
          setOpenSnackbar={setOpenSnackbar}
          data={data}
          setData={setData}
        />
      </Box>
      <MainColorButton label="登録" onClick={signUp} style={bottomButton} />
    </>
  );
};

export default CustomerCreator;
